import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { PasswordControlComponent } from '../password-control/password-control.component';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-password-confirm-control',
  templateUrl: './password-confirm-control.component.html',
  styleUrls: ['./password-confirm-control.component.scss'],
})
export class PasswordConfirmControlComponent
  extends PasswordControlComponent
  implements OnInit, AfterViewInit {
  @Input()
  parent?: PasswordControlComponent;

  protected setPasswordValidators(): void {
    super.setPasswordValidators();
    this.validators.push((control: AbstractControl) =>
      this.isSame(control, this.parent as PasswordControlComponent)
    );
  }
}
